import UIParamsToStateProvider from './UIParamsToStoreProvider';

export default UIParamsToStateProvider;
